<template>
  <span @click.prevent="openModal()">
    <svg v-if="!text" :class="{ 'svg-icon--xs': small }" class="svg-icon svg-icon--sm hover:text-primary text-gray-400 cursor-pointer">
      <use xlink:href="#icon-info"></use>
    </svg>
    <span v-if="text" class="cursor-help inline-block border-b border-dotted">
      {{ text }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    term: {
      type: String,
      required: true
    },

    text: {
      type: String,
      required: false
    },

    small: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    // The modal brings the markdown parser and every tooltip's text, so it loads
    // on the first click instead of with every page that shows an info icon.
    async openModal() {
      const { default: TooltipModal } = await import(/* webpackChunkName: "tooltip-modal" */ 'views/Modals/TooltipModal')
      this.$modal(TooltipModal, { term: this.term })
    }
  }
}
</script>
